<div class="row">
    <div class="col-md-3">
        <div class="mb-3">
            <label class="form-label">Year</label>
            <ng-select [items]="years" [(ngModel)]="selectedYear" (change)="onMonthYearChange()" [clearable]="false">
            </ng-select>
        </div>
    </div>
    <div class="col-md-3">
        <div class="mb-3">
            <label class="form-label">Month</label>
            <ng-select [items]="months" bindLabel="name" bindValue="number" [(ngModel)]="selectedMonth" (change)="onMonthYearChange()" [clearable]="false">
            </ng-select>
        </div>
    </div>
    <div class="col-md-6">
        <div class="mb-3">
            <label class="form-label">Week Selection </label>
            <ng-select [items]="weeks" bindLabel="dateKey" bindValue="dateKey" [(ngModel)]="selectedWeekKey" (change)="onWeekSelect()" [clearable]="false" placeholder="Select Week">
                <ng-template ng-label-tmp let-item="item">
                    <span class="text-primary fw-bold">
                        <i class="bi bi-calendar3 me-2"></i>
                        Week {{item.weekNum}}: {{item.start | date:'dd MMM'}} - {{item.end | date:'dd MMM'}}
                    </span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="d-flex align-items-center">
                        <i class="bi bi-calendar-event me-2 text-success"></i>
                        <span class="fw-bold text-gray-800">Week {{item.weekNum}}</span>
                        <span class="mx-2 text-muted">|</span>
                        <span class="text-muted">{{item.start | date:'dd MMM'}} - {{item.end | date:'dd MMM'}}</span>
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>
